import * as yup from 'yup';
import { ESU_FIELDS } from '@comicrelief/component-library';
import emailValidation from '../../utils/emailValidation';

const schemaOverride = yup.object({
  [ESU_FIELDS.EMAIL]: emailValidation
});

export default schemaOverride;
